

export function setCssVariables(){
    document.documentElement.style.setProperty('--primary-color', "#372349");
    document.documentElement.style.setProperty('--primary-color-lighter', "#6b3c70");
    document.documentElement.style.setProperty('--primary-color-text', "#fff1e6");
    document.documentElement.style.setProperty('--accent-color', "#f8b61a");
    document.documentElement.style.setProperty('--accent-color-text', "black");
    document.documentElement.style.setProperty('--white-text', "#fff1e6");
    document.documentElement.style.setProperty('--mat-select-background-color', "white");

    document.documentElement.style.setProperty('--warn-color-text', "white");
    document.documentElement.style.setProperty('--warn-color-background', "red");


}